import React from "react";

interface RadioProps {
	value: boolean;
	onChange?: (value: boolean) => void;
	variant: "dark" | "light";
}

const Radio = ({ variant, value, onChange }: RadioProps) => {
	let color = variant === "dark" ? "dark-accent" : "gray";
	return (
		<div
			onClick={() => {
				if (onChange) {
					onChange(!value);
				}
			}}
			className={`w-6 h-6 p-1 rounded-full border-2 transition-all border-${
				value ? "dark-accent" : color
			}`}
		>
			<div
				className={`w-full h-full flex rounded-full transition-all opacity-${
					value ? 100 : 0
				} bg-dark-accent`}
			></div>
		</div>
	);
};

Radio.defaultProps = {
	value: false,
	variant: "dark",
};

export default Radio;
